import { format, getDay, isSameDay, isSameMonth, startOfMonth } from "date-fns";
import locale from "date-fns/locale/nb";
import { useEffect, useState } from "react";
import DateItems from "src/components/dateselector/DateItems";
import IDateGroup from "src/components/dateselector/IDateGroup";
import SelectorWrapper from "src/components/selectorwrapper/SelectorWrapper";
import LeftArrowSvg from "src/components/svg/LeftArrowSvg";
import RightArrowSvg from "src/components/svg/RightArrowSvg";
import { useProgramDatesContext } from "src/lib/contexts/ProgramDatesWrapper";
import styles from './DateSelector.module.css';

//#region [Props]
type DateSelectorProps = {
	className?: string;
};
//#endregion

//#region [Component]
export default function DateSelector({ className }: DateSelectorProps) {
	const selectedDateContext = useProgramDatesContext();

	const [groupedDates, setGroupedDates] = useState<IDateGroup[] | null>(null);
	const [monthIndex, setMonthIndex] = useState(0);

	useEffect(() => {
		if (selectedDateContext.availableDates) {
			const _groupedDates = groupDates(selectedDateContext.availableDates);
			setGroupedDates(_groupedDates);
		}
	}, [selectedDateContext.availableDates]);

	useEffect(() => {
		// only run this the first time groupedDates is available
		if (groupedDates) {
			const idx = groupedDates.findIndex(gd => gd.dates.some(d => isSameDay(selectedDateContext.selectedDate!, d)));
			if (idx > 0) {
				setMonthIndex(idx);
			}

		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [groupedDates]);

	if (!groupedDates) {
		return null;
	}

	return <SelectorWrapper
		onClose={() => selectedDateContext.setShowSelectDateDialog(false)}
		heading="Velg dag">
		<div>
			<div className={styles.SMonthWrapper}>
				<button className={styles.SArrowButton} onClick={() => setMonthIndex(monthIndex - 1)} disabled={monthIndex === 0}>
					<LeftArrowSvg className={styles.SLeftArrowSvg} />
				</button>
				<div className={styles.SMonth}>{getMonthString(groupedDates[monthIndex]?.month)}</div>
				<button className={styles.SArrowButton} onClick={() => setMonthIndex(monthIndex + 1)} disabled={monthIndex >= groupedDates.length - 1}>
					<RightArrowSvg className={styles.SRightArrowSvg} />
				</button>
			</div>
			<DateItems
				month={groupedDates?.[monthIndex]}
				changeDate={(date: Date) => { selectedDateContext.setSelectedDate(date); selectedDateContext.setShowSelectDateDialog(false); }}
				selectedDate={selectedDateContext.selectedDate!} />
		</div>
	</SelectorWrapper>;
}
//#endregion


//#region [Other]

function getMonthString(month: Date | undefined | null) {
	if (!month) return "";
	return format(month, "MMMM yyyy", { locale });
}

function getMonthFirstDay(month: Date) {
	const som = getDay(startOfMonth(month)) - 1;
	return som < 0 ? 6 : som;
}

function groupDates(dates: Date[] | null | undefined): IDateGroup[] {
	let prevDate: Date | null = null;
	let currMonth: IDateGroup | null = null;
	const groupedDates: IDateGroup[] = [];

	dates?.forEach(d => {
		if (!prevDate || !isSameMonth(d, prevDate)) {
			prevDate = d;
			currMonth = { month: d, dates: [d] };
			groupedDates.push(currMonth);
		} else {
			currMonth?.dates.push(d);
		}
	});

	return groupedDates;
}

//#endregion